import HomeBannerImages from './homeBannerImages';
import ServiceTabs from './serviceTabs';
import breakpointChecker from './homeCarousel';

document.addEventListener('DOMContentLoaded', () => {
  HomeBannerImages();
  ServiceTabs();
  breakpointChecker();
});



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/home/home.js